import React from 'react';
import { motion } from 'framer-motion';
import { Users, Maximize, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import { banquets as venues } from '../data/banquets';
export function Banquets() {
  return <div className="w-full bg-club-canvas" data-id="element-609">
      {/* Page Banner */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden" data-id="element-610">
        <div className="absolute inset-0 z-0" data-id="element-611">
          <img src="https://images.unsplash.com/photo-1519167758481-83f550bb49b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Banquets & Events" className="w-full h-full object-cover" data-id="element-612" />
          <div className="absolute inset-0 bg-club-navy/50 mix-blend-multiply" data-id="element-613"></div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-614">
          <motion.span className="eyebrow text-club-gold mb-4 block" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-615">
            Unforgettable Occasions
          </motion.span>
          <motion.h1 className="text-5xl md:text-6xl font-serif text-white mb-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-616">
            Banquets & Events
          </motion.h1>
        </div>
      </section>

      {/* Intro */}
      <section className="py-20 px-4 max-w-4xl mx-auto text-center" data-id="element-617">
        <p className="text-xl text-club-ink/80 font-light leading-relaxed mb-8" data-id="element-618">
          From intimate private dinners to grand celebrations, Andhra Social &
          Cultural Association offers a selection of exquisite venues to host
          your most important events. Our dedicated events team and executive
          chef will work with you to create a bespoke experience tailored to
          your exact requirements.
        </p>
        <Link to="/contact" className="btn-primary" data-id="element-619">
          Enquire Now
        </Link>
      </section>

      {/* Venues Grid */}
      <section className="py-12 px-4 max-w-7xl mx-auto mb-24" data-id="element-620">
        <div className="space-y-16" data-id="element-621">
          {venues.map((venue, index) => <motion.div key={venue.id} className="flex flex-col lg:flex-row gap-12 bg-white border border-club-border rounded-sm overflow-hidden" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-622">
              <div className="w-full lg:w-1/2" data-id="element-623">
                <div className="h-full min-h-[300px] relative" data-id="element-624">
                  <img src={venue.image} alt={venue.name} className="absolute inset-0 w-full h-full object-cover" data-id="element-625" />
                </div>
              </div>
              <div className="w-full lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center" data-id="element-626">
                <h2 className="text-3xl mb-4" data-id="element-627">{venue.name}</h2>
                <p className="text-club-ink/70 leading-relaxed mb-8" data-id="element-628">
                  {venue.desc}
                </p>

                <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-629">
                  <div className="flex items-center gap-2 text-sm text-club-ink/80" data-id="element-630">
                    <Users size={16} className="text-club-gold" data-id="element-631" />
                    <span data-id="element-632">{venue.capacity}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-club-ink/80" data-id="element-633">
                    <Maximize size={16} className="text-club-gold" data-id="element-634" />
                    <span data-id="element-635">{venue.size}</span>
                  </div>
                </div>

                <div className="pt-6 border-t border-club-border flex gap-4" data-id="element-636">
                  <Link to={`/banquets/${venue.id}`} className="btn-primary" data-id="element-637">
                    View Details
                  </Link>
                  <Link to={`/banquets/${venue.id}#enquire`} className="btn-secondary" data-id="element-638">
                    Request Proposal
                  </Link>
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>
    </div>;
}